<div>
  <div class="col-sm-12 coldx">
    <h4>Tutti i rinvii della scadenza</h4>
	<ng-template *ngIf="rinviiList" ngFor let-rinvio [ngForOf]="rinviiList">
    <div class="row">
		<div labelTextInput [typeLabel]="'listModal'" [classLabel]="'col-sm-1'" [labelInput]="'Data'"
		[classInput]="'col-sm-3'" [valueInput]="rinvio.dataDa | dateformatter:'DD/MM/YYYY HH:mm'"></div>
		
		<div labelTextInput [typeLabel]="'listModal'" [classLabel]="'col-sm-2'" [labelInput]="'Motivo'"
		[classInput]="'col-sm-6'" [valueInput]="rinvio.motivo ? rinvio.motivo.label : ''"></div>
    </div>
    </ng-template>
  </div>
</div>